// CAUTION!

/**
 * The order is important!
 * The first id will be placed to the top.
 */

const priorization = [
    'alltagundwuensche_girokonto_psdgirokomfort',
    'alltagundwuensche_girokonto_psdgiropremium',
    'alltagundwuensche_girokonto_psdgirobasic',
    'alltagundwuensche_karteundratenkredit_goldcard',
    'alltagundwuensche_karteundratenkredit_classiccard',
];

// No mistake! .reverse is needed!
export default priorization.reverse();
